import { getRetailerOrBrandToken } from "@faire/help-center-utils/serialized-data/getRetailerOrBrandToken";
import { useStrictLocalization } from "@faire/web--source/common/localization";

import { useSelfServeContextStore } from "./SelfServeContext";
import { useInitializeEmailField } from "./useInitializeEmailField";
import { useIssueType } from "./useIssueType";
import { useNavigation } from "./useNavigation";

export const useEmailFormState = () => {
  const { emailUsInitial } = useInitializeEmailField();
  const { goToNextStep } = useNavigation();
  const { strictLocalize } = useStrictLocalization();
  const [{ selectedBrandOrder }] = useSelfServeContextStore([
    "selectedBrandOrder",
  ]);
  const { issueType } = useIssueType();
  const retailerOrBrandToken = getRetailerOrBrandToken();
  return {
    emailUsInitial,
    goToNextStep,
    strictLocalize,
    selectedBrandOrder,
    issueType,
    retailerOrBrandToken,
  };
};
